import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import BreadCrumb from 'shared/components/bread-crumb/bread-crumb/bread-crumb';

import styles from 'features/residents/resident-change-logs/views/components/columns/resident-organisation-unit-name-column/resident-organisation-unit-name-column.module.scss';

type Props = {
  organisationUnitName: string;
  organisationUnitAncestors: string[];
};

const ResidentOrganisationUnitNameColumn = ({ organisationUnitName, organisationUnitAncestors }: Props): React.JSX.Element => {
  const { t } = useTranslation('residentsChangeLog');

  const renderBreadCrumbs = (parentTitle: string, index: number): React.JSX.Element => (
    <Typography
      data-testid={`resident-breadcrumb-child-${index}`}
      key={`Resident_Breadcrumb_Child_${parentTitle}`}
      variant="caption"
      className={styles.breadCrumbItem}
    >
      {parentTitle}
    </Typography>
  );

  return (
    <div className="container">
      <Typography variant="body2" className={styles.residentName}>
        {t('residentOf')}
      </Typography>
      <Tooltip title={organisationUnitName}>
        <Typography variant="subtitle2" className={styles.organisationUnitName}>
          {organisationUnitName}
        </Typography>
      </Tooltip>
      <BreadCrumb
        showEllipsis={organisationUnitAncestors.length > 1}
        allElementNames={organisationUnitAncestors}
        data-testid={`resident-breadcrumb-child-${organisationUnitName}`}
        amountOfOrganisationUnitsShown={1}
      >
        {organisationUnitAncestors.map((parentTitle, index) => renderBreadCrumbs(parentTitle, index))}
      </BreadCrumb>
    </div>
  );
};

export default ResidentOrganisationUnitNameColumn;
